import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 15rem;

  h2 {
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }

  .projects {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project {
      padding: 2rem 1.8rem;
      background-color: var(--tile-bg);
      border-radius: 1.2rem;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: var(--tile-text);
      &:hover {
        transform: translateY(-5px);
        background-color: var(--tile-hover-bg);
      }

      header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--header-color);
        margin-bottom: 3.6rem;
        .project-links {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        a > img {
          width: 1rem;
        }
      }

      h3 {
        margin-bottom: 2rem;
      }

      p {
        letter-spacing: 0.12rem;
        margin-bottom: 2rem;
        a {
          color: var(--link-color);
          border-bottom: 1px solid var(--link-border);
          transition: color 0.25s;
          &:hover {
            color: var(--link-hover-color);
          }
        }
      }

      footer {
        margin-top: auto;
        .tech-list {
          display: flex;
          flex-wrap: wrap;
          flex-direction: row;
          align-items: center;
          gap: 1rem;
          font-size: 1.3rem;
          opacity: 0.6;
        }
      }
    }
  }

  @media (max-width: 960px) {
    .projects {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 1080px) {
   .projects {
      grid-template-columns: 2fr 2fr;
    }
  }

  @media (max-width: 740px) {
    .projects {
      grid-template-columns: 1fr;
    }
  }
`;
